import type { ComponentType, SVGProps } from 'react';
import logoMobileCirclekVector from '~/assets/img/circlek/logo.svg?react';
import { OboardingImagesCirclek } from '~/assets/img/circlek/onboarding';
import EmptyCartJiffy from '~/assets/img/jiffy/empty_cart.png';
import EmptyOrdersJiffy from '~/assets/img/jiffy/empty_orders.png';
import FavsJiffy from '~/assets/img/jiffy/favs.png';
import EmptyAddressJiffy from '~/assets/img/jiffy/geolocation.png';
import ReferralJiffy from '~/assets/img/jiffy/referral.png';
import SearchJiffy from '~/assets/img/jiffy/search.png';
import EmptyWalletJiffy from '~/assets/img/jiffy/wallet.png';
import { OboardingImagesKids } from '~/assets/img/kids/onboarding';
import logoMobileLocaleeVector from '~/assets/img/localee/logo.svg?react';
import { OboardingImagesLocalee } from '~/assets/img/localee/onboarding';
import ReferralLocalee from '~/assets/img/localee/referral.png';
import emptyCartVariant1 from '~/assets/img/variant1/empty-cart.png';
import { CompanyName } from '~/company/interface';

// ONBOARDING IMAGES
import NotFoundPageCD from '../assets/img/404_page.png';
import NotFoundPageCirclek from '../assets/img/circlek/404.png';
import EmptyCartCirclek from '../assets/img/circlek/empty_cart.png';
import EmptyOrdersCirclek from '../assets/img/circlek/empty_orders.png';
import FavsCirclek from '../assets/img/circlek/favs.png';
import EmptyAddressCirclek from '../assets/img/circlek/geolocation.png';
import logoDarkCirclek from '../assets/img/circlek/logo_circlek_red.png';
import logoLightCirclek from '../assets/img/circlek/logo_circlek_white.png';
import ReferralCirclek from '../assets/img/circlek/referral.png';
import SearchCirclek from '../assets/img/circlek/search.png';
import TimeCirclek from '../assets/img/circlek/time.png';
import EmptyWalletCirclek from '../assets/img/circlek/wallet.png';
import { OboardingImages as OboardingImagesCd } from '../assets/img/citydrinks';
import EmptyAddressesCD from '../assets/img/citydrinks/empty_address.png';
import EmptyFavsImageCD from '../assets/img/citydrinks/empty_favs.png';
import EmptyOrdersCD from '../assets/img/citydrinks/empty_orders.png';
import EmptyPaymentsCD from '../assets/img/citydrinks/empty_payments.png';
import EmptyWaitlistCD from '../assets/img/citydrinks/empty_waitlist.png';
import ReferralCD from '../assets/img/citydrinks/refer_friend.png';
import TimeCD from '../assets/img/closed_clock.png';
import Electronium404Page from '../assets/img/electronium/404_page.png';
import ElectroniumEmptyAddress from '../assets/img/electronium/empty_address.png';
import ElectroniumEmptyCart from '../assets/img/electronium/empty_cart.png';
import ElectroniumEmptyFavs from '../assets/img/electronium/empty_favs.png';
import ElectroniumEmptyOrders from '../assets/img/electronium/empty_orders.png';
import ElectroniumEmptyPayments from '../assets/img/electronium/empty_payments.png';
import ElectroniumEmptyProduct from '../assets/img/electronium/empty_product.png';
import ElectroniumEmptySearch from '../assets/img/electronium/empty_search.png';
import ElectroniumEmptyWaitlist from '../assets/img/electronium/empty_waitlist.png';
import ElectroniumHeaderEmptySearch from '../assets/img/electronium/header_empty_search.png';
import ElectroniumLogo from '../assets/img/electronium/logo.png';
import { ElectroniumOnboardingImages } from '../assets/img/electronium/onboarding';
import ElectroniumReferFriend from '../assets/img/electronium/refer_friend.png';
import arEg from '../assets/img/flags/ar-EG.png';
import enGb from '../assets/img/flags/en-GB.png';
import isIS from '../assets/img/flags/is-IS.png';
import plPL from '../assets/img/flags/pl-PL.png';
import { OboardingImages as OnboardingImagesHeimkaup } from '../assets/img/heimkaup/onboarding';
import NotFoundPageJiffy from '../assets/img/jiffy/404.png';
import logoDarkJiffy from '../assets/img/jiffy/logo_dark.png';
import logoLightJiffy from '../assets/img/jiffy/logo_light.png';
import NotFoundKids from '../assets/img/kids/404.png';
// import BellKids from '../assets/img/kids/bell.png';
// import CartKids from '../assets/img/kids/cart.png';
import EmptyCartKids from '../assets/img/kids/empty_cart.png';
import EmptyOrdersKids from '../assets/img/kids/empty_orders.png';
// import EmptySubsKids from '../assets/img/kids/empty_subs.png';
import FavsKids from '../assets/img/kids/favs.png';
import GeoKids from '../assets/img/kids/geolocation.png';
import logoKids from '../assets/img/kids/logo.png';
import ReferralKids from '../assets/img/kids/referral.png';
// import ReviewsKids from '../assets/img/kids/reviews.png';
import SearchKids from '../assets/img/kids/search.png';
// import SmtwrongKids from '../assets/img/kids/smtwrong.png';
import TimeKids from '../assets/img/kids/time.png';
// import TorchKids from '../assets/img/kids/torch.png';
import WalletKids from '../assets/img/kids/wallet.png';
import NotFoundPageLocalee from '../assets/img/localee/404.png';
import EmptyOrdersLocalee from '../assets/img/localee/empty_orders.png';
import EmptyFavsImageLocalee from '../assets/img/localee/favs.png';
import EmptyAddressesLocalee from '../assets/img/localee/geolocation.png';
import QRMaxiLocalee from '../assets/img/localee/qr_maxi.png';
import QRMiniLocalee from '../assets/img/localee/qr_mini.png';
import SearchLocalee from '../assets/img/localee/search.png';
import TimeLocalee from '../assets/img/localee/time.png';
import EmptyPaymentsLocalee from '../assets/img/localee/wallet.png';
import logoDarkCD from '../assets/img/logo_cd_color.svg';
import LogoColorCD from '../assets/img/logo_cd_color_vertical.svg';
import LogoWhiteCD from '../assets/img/logo_cd_white.svg';
import logoDarkLocalee from '../assets/img/logo_localee.svg';
import logoLightLocalee from '../assets/img/logo_localee_orange.svg';
import joinLoyality from '../assets/img/onboarding/join_loyality.png';
import referFriend from '../assets/img/onboarding/refer_friend.png';
import shareThoughts from '../assets/img/onboarding/share_thoughts.png';
import signUp from '../assets/img/onboarding/sign_up.png';
import spotTheLight from '../assets/img/onboarding/spot_the_lighting.png';
import swiftDelivery from '../assets/img/onboarding/swift_delivery.png';
import trackDelivery from '../assets/img/onboarding/track_delivery.png';
import unlockComplementary from '../assets/img/onboarding/unlock_complementary.png';
import { OboardingImages as OboardingImagesOskuhus } from '../assets/img/oskohus/onboarding';
import QRMaxiCD from '../assets/img/qr_footer.png';
import QRMiniCD from '../assets/img/qr_header.png';
import { OboardingImages as OboardingImagesVilo } from '../assets/img/vilo';
import NotFoundPageVilo from '../assets/img/vilo/404.png';
import EmptyCartVilo from '../assets/img/vilo/empty_cart.png';
import EmptyOrdersVilo from '../assets/img/vilo/empty_orders.png';
import FavsVilo from '../assets/img/vilo/favs.png';
import EmptyAddressVilo from '../assets/img/vilo/geolocation.png';
import LogoDarkVilo from '../assets/img/vilo/logo_dark.svg';
import LogoLightVilo from '../assets/img/vilo/logo_light.svg';
import QRMaxiVilo from '../assets/img/vilo/qr_footer.png';
import QRMiniVilo from '../assets/img/vilo/qr_primary.png';
import ReferralVilo from '../assets/img/vilo/referral.png';
import SearchVilo from '../assets/img/vilo/search.png';
import TimeVilo from '../assets/img/vilo/time.png';
import EmptyWalletVilo from '../assets/img/vilo/wallet.png';

// import InternetJiffy from '~/assets/img/jiffy/smtwrong.png';

import ContactUsBanner1Cerise from '~/assets/img/ceries/banner1.png';
import ContactUsBanner2Cerise from '~/assets/img/ceries/banner2.png';
import logoAgeRestrictionMain from '~/assets/img/heimkaup/age_restriction_logo_main.png';
import logoAgeRestrictionSecondary from '~/assets/img/heimkaup/age_restriction_logo_secondary.png';
import EmptyWaitlistSaas from '~/assets/img/heimkaup/empty_waitlist.png';
import logoMobileHeimkaupVector from '~/assets/img/heimkaup/logo.svg?react';
import logoDarkHeimkaup from '~/assets/img/heimkaup/logo_dark.png';
import logoLightHeimkaup from '~/assets/img/heimkaup/logo_light.png';
import pickupLogoHeimkaup from '~/assets/img/heimkaup/pickup-logo.png';
import logoDarkOskuhus from '~/assets/img/oskohus/logo_dark.png';
import logoLightOskuhus from '~/assets/img/oskohus/logo_light.png';

import NotFoundPageCerise from '../assets/img/ceries/404.png';
import EmptyCartCerise from '../assets/img/ceries/empty_cart.png';
import EmptyOrdersCerise from '../assets/img/ceries/empty_orders.png';
import EmptyWaitlistCerise from '../assets/img/ceries/empty_waitlist.png';
import FavsCerise from '../assets/img/ceries/favs.png';
import GeoCerise from '../assets/img/ceries/geolocation.png';
import logoDarkCerise from '../assets/img/ceries/logo_dark.png';
import logoLightCerise from '../assets/img/ceries/logo_light.png';
import { OboardingImages as OboardingImagesCerise } from '../assets/img/ceries/onboarding';
import ReferralCerise from '../assets/img/ceries/referral.png';
import SearchCerise from '../assets/img/ceries/search.png';
import TimeCerise from '../assets/img/ceries/smtwrong.png';
import EmptyWalletCerise from '../assets/img/ceries/wallet.png';
import EmptyCartCD from '../assets/img/citydrinks/empty_cart.png';
import EmptyProductCD from '../assets/img/citydrinks/empty_product.svg';
import EmptySearchCD from '../assets/img/citydrinks/empty_search.png';
import EmptyHeaderSearchCD from '../assets/img/citydrinks/header_empty_search.png';
import NewsletterNotificationCD from '../assets/img/citydrinks/newsletter_notification.png';
import LogoDubaiExpress from '../assets/img/dubaiexpress/DE_logo_rus_color_hor.svg';
import LogoDubaiExpressComBlack from '../assets/img/dubaiexpresscom/DE_logo_eng_black_hor.svg';
import LogoDubaiExpressComColor from '../assets/img/dubaiexpresscom/DE_logo_eng_color_hor.svg';
import NotFoundPageHeimkaup from '../assets/img/heimkaup/404.png';
import EmptyCartHeimkaup from '../assets/img/heimkaup/empty_cart.png';
import EmptyOrdersHeimkaup from '../assets/img/heimkaup/empty_orders.png';
import FavsHeimkaup from '../assets/img/heimkaup/favs.png';
import GeoHeimkaup from '../assets/img/heimkaup/geolocation.png';
import ReferralHeimkaup from '../assets/img/heimkaup/referral.png';
import SearchHeimkaup from '../assets/img/heimkaup/search.png';
import TimeHeimkaup from '../assets/img/heimkaup/time.png';
import EmptyWalletHeimkaup from '../assets/img/heimkaup/wallet.png';
import NotFoundPageMcosmetic from '../assets/img/mcosmetic/404_page.png';
import EmptyAddressMcosmetic from '../assets/img/mcosmetic/empty_address.png';
import EmptyCartMcosmetic from '../assets/img/mcosmetic/empty_cart.png';
import EmptyFavsMcosmetic from '../assets/img/mcosmetic/empty_favs.png';
import EmptyHeaderSearchMcosmetic from '../assets/img/mcosmetic/empty_header_search.png';
import EmptyOrdersMcosmetic from '../assets/img/mcosmetic/empty_orders.png';
import EmptyPaymentsMcosmetic from '../assets/img/mcosmetic/empty_payments.png';
import EmptyProductMcosmetic from '../assets/img/mcosmetic/empty_product.png';
import EmptySearchMcosmetic from '../assets/img/mcosmetic/empty_search.png';
import EmptyWaitlistMcosmetic from '../assets/img/mcosmetic/empty_waitlist.png';
import LogoMcosmetic from '../assets/img/mcosmetic/logo.svg';
import LogoMcosmeticVector from '../assets/img/mcosmetic/logo.svg?react';
import LogoMobileMcosmetic from '../assets/img/mcosmetic/logo_mobile.svg';
import LogoMobileMcosmeticVector from '../assets/img/mcosmetic/logo_mobile.svg?react';
import { OnboardingImagesMcosmetic } from '../assets/img/mcosmetic/onboarding';
import ProfileBackgroundMcosmetic from '../assets/img/mcosmetic/profile_bg.png';
import ReferralMcosmetic from '../assets/img/mcosmetic/refer_friend.svg';
import NotFoundPageOcado from '../assets/img/ocado/404_page.png';
import EmptyAddressOcado from '../assets/img/ocado/empty_address.png';
import EmptyCartOcado from '../assets/img/ocado/empty_cart.png';
import EmptyFavsOcado from '../assets/img/ocado/empty_favs.png';
import EmptyOrdersOcado from '../assets/img/ocado/empty_orders.png';
import EmptyPaymentsOcado from '../assets/img/ocado/empty_payments.png';
import EmptyProductOcado from '../assets/img/ocado/empty_product.png';
import EmptySearchOcado from '../assets/img/ocado/empty_search.png';
import EmptyWaitlistOcado from '../assets/img/ocado/empty_waitlist.png';
import EmptyHeaderSearchOcado from '../assets/img/ocado/header_empty_search.png';
import LogoOcado from '../assets/img/ocado/logo.png';
import LogoDarkOcado from '../assets/img/ocado/logo_dark.png';
import ReferralOcado from '../assets/img/ocado/refer_friend.png';
import NotFoundPageOskuhus from '../assets/img/oskohus/404.png';
import EmptyCartOskuhus from '../assets/img/oskohus/empty_cart.png';
import EmptyOrdersOskuhus from '../assets/img/oskohus/empty_orders.png';
import FavsOskuhus from '../assets/img/oskohus/favs.png';
import GeoOskuhus from '../assets/img/oskohus/geolocation.png';
import ReferralOskuhus from '../assets/img/oskohus/referral.png';
import SearchOskuhus from '../assets/img/oskohus/search.png';
import TimeOskuhus from '../assets/img/oskohus/time.png';
import EmptyWalletOskuhus from '../assets/img/oskohus/wallet.png';
import NotFoundPageStorrd from '../assets/img/storrd/404_page.png';
import EmptyAddressStorrd from '../assets/img/storrd/empty_address.png';
import EmptyCartStorrd from '../assets/img/storrd/empty_cart.png';
import EmptyFavsStorrd from '../assets/img/storrd/empty_favs.png';
import EmptyOrdersStorrd from '../assets/img/storrd/empty_orders.png';
import EmptyPaymentsStorrd from '../assets/img/storrd/empty_payments.png';
import EmptyProductStorrd from '../assets/img/storrd/empty_product.png';
import EmptySearchStorrd from '../assets/img/storrd/empty_search.png';
import EmptyWaitlistStorrd from '../assets/img/storrd/empty_waitlist.png';
import EmptyHeaderSearchStorrd from '../assets/img/storrd/header_empty_search.png';
import LogoStorrd from '../assets/img/storrd/logo.png';
import { OnboardingImagesStorrd } from '../assets/img/storrd/onboarding';
import ReferralStorrd from '../assets/img/storrd/refer_friend.png';

interface CompanyImages {
  onboarding: unknown;
  profileBackground?: string;
  '404': {
    notFound: string;
  };
  cart: {
    empty: string;
  };
  address: {
    empty: string;
    pickupIcon?: string;
  };
  locale: Record<string, string>;
  logo: {
    dark: string;
    light: string;
    vector?: ComponentType<SVGProps<SVGSVGElement>>;
  };
  logoMobile?: {
    dark: string;
    light: string;
    vector?: ComponentType<SVGProps<SVGSVGElement>>;
  };
  ageRestriction: {
    white: string;
    color: string;
  };
  qr: {
    mini: string;
    maxi: string;
  };
  payments: {
    empty: string;
  };
  order: {
    empty: string;
  };
  referral: {
    hero: string;
  };
  favs: {
    empty: string;
  };
  search: {
    empty: string;
  };
  time: string;
  waitlist: {
    empty: string;
  };
  product: {
    empty: string;
  };
  newsletter: {
    icon: string;
  };
  header: {
    search: {
      empty: string;
    };
  };
  others?: {
    [key: string]: string;
  };
}

export const IMAGES_BY_COMPANY: Record<CompanyName, CompanyImages> = {
  [CompanyName.CityDrinks]: {
    onboarding: OboardingImagesCd,
    404: {
      notFound: NotFoundPageCD,
    },
    cart: {
      empty: EmptyCartCD,
    },
    address: {
      empty: EmptyAddressesCD,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: logoDarkCD,
      light: LogoWhiteCD,
    },
    ageRestriction: {
      white: LogoWhiteCD,
      color: LogoColorCD,
    },
    qr: {
      mini: QRMiniCD,
      maxi: QRMaxiCD,
    },
    payments: {
      empty: EmptyPaymentsCD,
    },
    order: {
      empty: EmptyOrdersCD,
    },
    referral: {
      hero: ReferralCD,
    },
    favs: {
      empty: EmptyFavsImageCD,
    },
    search: {
      empty: EmptySearchCD,
    },
    time: TimeCD,
    waitlist: {
      empty: EmptyWaitlistCD,
    },
    product: {
      empty: EmptyProductCD,
    },
    newsletter: {
      icon: NewsletterNotificationCD,
    },
    header: {
      search: {
        empty: EmptyHeaderSearchCD,
      },
    },
  },
  [CompanyName.Localee]: {
    onboarding: OboardingImagesLocalee,
    404: {
      notFound: NotFoundPageLocalee,
    },
    cart: {
      empty: emptyCartVariant1,
    },
    address: {
      empty: EmptyAddressesLocalee,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: logoDarkLocalee,
      light: logoLightLocalee,
      vector: logoMobileLocaleeVector,
    },
    ageRestriction: {
      white: logoLightLocalee,
      color: logoDarkLocalee,
    },
    qr: {
      mini: QRMiniLocalee,
      maxi: QRMaxiLocalee,
    },
    payments: {
      empty: EmptyPaymentsLocalee,
    },
    order: {
      empty: EmptyOrdersLocalee,
    },
    referral: {
      hero: ReferralLocalee,
    },
    favs: {
      empty: EmptyFavsImageLocalee,
    },
    search: {
      empty: SearchLocalee,
    },
    time: TimeLocalee,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundPageLocalee,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchLocalee,
      },
    },
  },
  [CompanyName.CircleK]: {
    onboarding: OboardingImagesCirclek,
    404: {
      notFound: NotFoundPageCirclek,
    },
    cart: {
      empty: EmptyCartCirclek,
    },
    address: {
      empty: EmptyAddressCirclek,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: logoDarkCirclek,
      light: logoDarkCirclek,
      vector: logoMobileCirclekVector,
    },
    ageRestriction: {
      white: logoLightCirclek,
      color: logoDarkCirclek,
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyWalletCirclek,
    },
    order: {
      empty: EmptyOrdersCirclek,
    },
    referral: {
      hero: ReferralCirclek,
    },
    favs: {
      empty: FavsCirclek,
    },
    search: {
      empty: SearchCirclek,
    },
    time: TimeCirclek,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundPageCirclek,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchCirclek,
      },
    },
  },
  [CompanyName.Vilo]: {
    onboarding: OboardingImagesVilo,
    404: {
      notFound: NotFoundPageVilo,
    },
    cart: {
      empty: EmptyCartVilo,
    },
    address: {
      empty: EmptyAddressVilo,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: LogoDarkVilo,
      light: LogoLightVilo,
    },
    ageRestriction: {
      white: LogoLightVilo,
      color: LogoDarkVilo,
    },
    qr: {
      mini: QRMiniVilo,
      maxi: QRMaxiVilo,
    },
    payments: {
      empty: EmptyWalletVilo,
    },
    order: {
      empty: EmptyOrdersVilo,
    },
    referral: {
      hero: ReferralVilo,
    },
    favs: {
      empty: FavsVilo,
    },
    search: {
      empty: SearchVilo,
    },
    time: TimeVilo,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundPageVilo,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchVilo,
      },
    },
  },
  [CompanyName.Jiffy]: {
    onboarding: {
      swiftDelivery,
      spotTheLight,
      unlockComplementary,
      trackDelivery,
      shareThoughts,
      joinLoyality,
      referFriend,
      signUp,
    },
    404: {
      notFound: NotFoundPageJiffy,
    },
    cart: {
      empty: EmptyCartJiffy,
    },
    address: {
      empty: EmptyAddressJiffy,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: logoDarkJiffy,
      light: logoLightJiffy,
    },
    ageRestriction: {
      white: logoLightJiffy,
      color: logoDarkJiffy,
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyWalletJiffy,
    },
    order: {
      empty: EmptyOrdersJiffy,
    },
    referral: {
      hero: ReferralJiffy,
    },
    favs: {
      empty: FavsJiffy,
    },
    search: {
      empty: SearchJiffy,
    },
    time: TimeLocalee,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundPageJiffy,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchJiffy,
      },
    },
  },
  [CompanyName.Kids]: {
    onboarding: OboardingImagesKids,
    404: {
      notFound: NotFoundKids,
    },
    cart: {
      empty: EmptyCartKids,
    },
    address: {
      empty: GeoKids,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: logoKids,
      light: logoKids,
    },
    ageRestriction: {
      white: logoKids,
      color: logoKids,
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: WalletKids,
    },
    order: {
      empty: EmptyOrdersKids,
    },
    referral: {
      hero: ReferralKids,
    },
    favs: {
      empty: FavsKids,
    },
    search: {
      empty: SearchKids,
    },
    time: TimeKids,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundKids,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchKids,
      },
    },
  },
  [CompanyName.Electronium]: {
    onboarding: ElectroniumOnboardingImages,
    404: {
      notFound: Electronium404Page,
    },
    cart: {
      empty: ElectroniumEmptyCart,
    },
    address: {
      empty: ElectroniumEmptyAddress,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: ElectroniumLogo,
      light: ElectroniumLogo,
    },
    ageRestriction: {
      white: ElectroniumLogo,
      color: ElectroniumLogo,
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: ElectroniumEmptyPayments,
    },
    order: {
      empty: ElectroniumEmptyOrders,
    },
    referral: {
      hero: ElectroniumReferFriend,
    },
    favs: {
      empty: ElectroniumEmptyFavs,
    },
    search: {
      empty: ElectroniumEmptySearch,
    },
    time: '',
    waitlist: {
      empty: ElectroniumEmptyWaitlist,
    },
    product: {
      empty: ElectroniumEmptyProduct,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: ElectroniumHeaderEmptySearch,
      },
    },
  },
  [CompanyName.Oskuhus]: {
    onboarding: OboardingImagesOskuhus,
    404: {
      notFound: NotFoundPageOskuhus,
    },
    cart: {
      empty: EmptyCartOskuhus,
    },
    address: {
      empty: GeoOskuhus,
    },
    locale: {
      en: enGb,
      ar: arEg,
    },
    logo: {
      dark: logoDarkOskuhus,
      light: logoLightOskuhus,
    },
    ageRestriction: {
      white: logoLightOskuhus,
      color: logoDarkOskuhus,
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyWalletOskuhus,
    },
    order: {
      empty: EmptyOrdersOskuhus,
    },
    referral: {
      hero: ReferralOskuhus,
    },
    favs: {
      empty: FavsOskuhus,
    },
    search: {
      empty: SearchOskuhus,
    },
    time: TimeOskuhus,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundPageOskuhus,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchOskuhus,
      },
    },
  },
  [CompanyName.Heimkaup]: {
    onboarding: OnboardingImagesHeimkaup,
    404: {
      notFound: NotFoundPageHeimkaup,
    },
    cart: {
      empty: EmptyCartHeimkaup,
    },
    address: {
      empty: GeoHeimkaup,
      pickupIcon: pickupLogoHeimkaup,
    },
    locale: {
      en: enGb,
      pl: plPL,
      is: isIS,
    },
    logo: {
      dark: logoDarkHeimkaup,
      light: logoLightHeimkaup,
      vector: logoMobileHeimkaupVector,
    },
    logoMobile: {
      dark: logoDarkHeimkaup,
      light: logoLightHeimkaup,
      vector: logoMobileHeimkaupVector,
    },
    ageRestriction: {
      white: logoAgeRestrictionSecondary,
      color: logoAgeRestrictionMain,
    },

    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyWalletHeimkaup,
    },
    order: {
      empty: EmptyOrdersHeimkaup,
    },
    referral: {
      hero: ReferralHeimkaup,
    },
    favs: {
      empty: FavsHeimkaup,
    },
    search: {
      empty: SearchHeimkaup,
    },
    time: TimeHeimkaup,
    waitlist: {
      empty: EmptyWaitlistSaas,
    },
    product: {
      empty: NotFoundPageHeimkaup,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchHeimkaup,
      },
    },
  },
  [CompanyName.Cerise]: {
    onboarding: OboardingImagesCerise,
    404: {
      notFound: NotFoundPageCerise,
    },
    cart: {
      empty: EmptyCartCerise,
    },
    address: {
      empty: GeoCerise,
    },
    locale: {
      en: enGb,
      pl: plPL,
      is: isIS,
    },
    logo: {
      dark: logoDarkCerise,
      light: logoLightCerise,
    },
    ageRestriction: {
      white: '',
      color: '',
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyWalletCerise,
    },
    order: {
      empty: EmptyOrdersCerise,
    },
    referral: {
      hero: ReferralCerise,
    },
    favs: {
      empty: FavsCerise,
    },
    search: {
      empty: SearchCerise,
    },
    time: TimeCerise,
    waitlist: {
      empty: EmptyWaitlistCerise,
    },
    product: {
      empty: NotFoundPageCerise,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: SearchCerise,
      },
    },
    others: {
      banner_1: ContactUsBanner1Cerise,
      banner_2: ContactUsBanner2Cerise,
    },
  },
  [CompanyName.DubaiExpress]: {
    onboarding: '',
    404: {
      notFound: '',
    },
    cart: {
      empty: '',
    },
    address: {
      empty: '',
    },
    locale: {
      en: enGb,
      ru: '',
    },
    logo: {
      dark: LogoDubaiExpress,
      light: LogoDubaiExpress,
    },
    ageRestriction: {
      white: '',
      color: '',
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: '',
    },
    order: {
      empty: '',
    },
    referral: {
      hero: '',
    },
    favs: {
      empty: '',
    },
    search: {
      empty: '',
    },
    time: '',
    waitlist: {
      empty: '',
    },
    product: {
      empty: '',
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: '',
      },
    },
  },
  [CompanyName.DubaiExpressCom]: {
    onboarding: '',
    404: {
      notFound: '',
    },
    cart: {
      empty: '',
    },
    address: {
      empty: '',
    },
    locale: {
      en: enGb,
    },
    logo: {
      dark: LogoDubaiExpressComBlack,
      light: LogoDubaiExpressComColor,
    },
    ageRestriction: {
      white: '',
      color: '',
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: '',
    },
    order: {
      empty: '',
    },
    referral: {
      hero: '',
    },
    favs: {
      empty: '',
    },
    search: {
      empty: '',
    },
    time: '',
    waitlist: {
      empty: '',
    },
    product: {
      empty: '',
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: '',
      },
    },
  },
  [CompanyName.Storrd]: {
    onboarding: OnboardingImagesStorrd,
    404: {
      notFound: NotFoundPageStorrd,
    },
    cart: {
      empty: EmptyCartStorrd,
    },
    address: {
      empty: EmptyAddressStorrd,
    },
    locale: {
      en: enGb,
    },
    logo: {
      dark: LogoStorrd,
      light: LogoStorrd,
    },
    ageRestriction: {
      white: '',
      color: '',
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyPaymentsStorrd,
    },
    order: {
      empty: EmptyOrdersStorrd,
    },
    referral: {
      hero: ReferralStorrd,
    },
    favs: {
      empty: EmptyFavsStorrd,
    },
    search: {
      empty: EmptySearchStorrd,
    },
    time: '',
    waitlist: {
      empty: EmptyWaitlistStorrd,
    },
    product: {
      empty: EmptyProductStorrd,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: EmptyHeaderSearchStorrd,
      },
    },
  },
  [CompanyName.MCosmetic]: {
    onboarding: OnboardingImagesMcosmetic,
    profileBackground: ProfileBackgroundMcosmetic,
    404: {
      notFound: NotFoundPageMcosmetic,
    },
    cart: {
      empty: EmptyCartMcosmetic,
    },
    address: {
      empty: EmptyAddressMcosmetic,
    },
    locale: {
      en: enGb,
      uz: '',
    },
    logo: {
      dark: LogoMcosmetic,
      light: LogoMcosmetic,
      vector: LogoMcosmeticVector,
    },
    logoMobile: {
      dark: LogoMobileMcosmetic,
      light: LogoMobileMcosmetic,
      vector: LogoMobileMcosmeticVector,
    },
    ageRestriction: {
      white: '',
      color: '',
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyPaymentsMcosmetic,
    },
    order: {
      empty: EmptyOrdersMcosmetic,
    },
    referral: {
      hero: ReferralMcosmetic,
    },
    favs: {
      empty: EmptyFavsMcosmetic,
    },
    search: {
      empty: EmptySearchMcosmetic,
    },
    time: '',
    waitlist: {
      empty: EmptyWaitlistMcosmetic,
    },
    product: {
      empty: EmptyProductMcosmetic,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: EmptyHeaderSearchMcosmetic,
      },
    },
  },
  [CompanyName.Ocado]: {
    onboarding: '',
    404: {
      notFound: NotFoundPageOcado,
    },
    cart: {
      empty: EmptyCartOcado,
    },
    address: {
      empty: EmptyAddressOcado,
    },
    locale: {
      en: enGb,
    },
    logo: {
      dark: LogoDarkOcado,
      light: LogoOcado,
    },
    ageRestriction: {
      white: '',
      color: '',
    },
    qr: {
      mini: '',
      maxi: '',
    },
    payments: {
      empty: EmptyPaymentsOcado,
    },
    order: {
      empty: EmptyOrdersOcado,
    },
    referral: {
      hero: ReferralOcado,
    },
    favs: {
      empty: EmptyFavsOcado,
    },
    search: {
      empty: EmptySearchOcado,
    },
    time: '',
    waitlist: {
      empty: EmptyWaitlistOcado,
    },
    product: {
      empty: EmptyProductOcado,
    },
    newsletter: {
      icon: '',
    },
    header: {
      search: {
        empty: EmptyHeaderSearchOcado,
      },
    },
  },
};
